export default __webpack_public_path__ + "static/10-d0025912b392835081d30c78a3b1e0f7.webp";